import Alpine from "alpinejs";
import "./controllers/files";
import "./controllers/settings";
import "./controllers/analytics";
import "./controllers/post-form";
import "./controllers/option";
import "./controllers/notifications";
import "./controllers/translations";
import "./controllers/app_notifications";
import countries from "i18n-iso-countries";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

import languages from "@cospired/i18n-iso-languages";

languages.registerLocale(require("@cospired/i18n-iso-languages/langs/en.json"));

window.getLanguages = () => {
	let langs = languages.getNames("en");
	let langsWithNames = Array.from(Object.keys(langs), (lang) => {
		return {
			code: lang,
			name: langs[lang],
		};
	});

	langsWithNames.sort((a, b) =>
		a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
	);

	return langsWithNames;
};

window.getCountryName = (alpha2) => {
	return countries.getName(
		alpha2,
		navigator.language.slice(0, 2).toLowerCase(),
		{ select: "alias" },
	);
};

window.status = (response) => {
	if (response.status >= 200 && response.status < 300) {
		return Promise.resolve(response);
	} else {
		return Promise.reject(new Error(response.statusText));
	}
};

window.json = (response) => {
	return response.json();
};

document.addEventListener("alpine:init", () => {
	Alpine.data("postsListController", () => ({
		posts: [],
		tab: "draft",
		query: "",
		// No query parameters such as before/after
		searchURL: new URL(window.location.origin + window.location.pathname),

		setup(posts) {
			this.posts = posts;

			const urlParams = new URLSearchParams(window.location.search);
			let status = urlParams.get("status");
			this.tab = status ? status : "draft";

			let query = urlParams.get("query");
			this.query = query ? query : "";
		},

		doSearch() {
			let searchQuery = prompt("Search Query", this.query);
			if (!searchQuery) return;

			this.searchURL.searchParams.set("status", "search");
			this.searchURL.searchParams.set("query", searchQuery);
			window.location.href = this.searchURL.toString();
		},
	}));
});

document.addEventListener("alpine:init", () => {
	Alpine.data("permissionsController", () => ({
		advanced: false,
		roles: null,
		permissions: {},

		setup(roles, permissions, refresh) {
			this.roles = roles;
			this.permissions = permissions;

			if (refresh) {
				this.roleSelected();
			} else {
				this.advanced = true;
			}
		},

		roleSelected() {
			let role = document.getElementById("role").value;

			if (role !== "" && role !== "Custom") {
				let permissions = {};
				for (const [key, _] of Object.entries(this.permissions)) {
					permissions[key] = false;
				}
				this.roles[role].permissions.forEach(function (p) {
					permissions[p] = true;
				});
				this.permissions = permissions;
			}

			if (role === "Custom") {
				this.advanced = true;
			}
		},

		permissionChanged() {
			document.getElementById("role").value = "Custom";
		},
	}));
});

document.addEventListener("alpine:init", () => {
	Alpine.data("navMenuController", () => ({
		menu: [],

		setup(menu) {
			this.menu = menu;
		},

		addMenuItem() {
			this.menu.push({ label: "", path: "" });
		},

		moveMenuItem(index) {
			let item = this.menu.splice(index, 1);
			this.menu.splice(index - 1, 0, item[0]);
		},

		deleteMenuItem(index) {
			this.menu.splice(index, 1);
		},
	}));
});

document.addEventListener("alpine:init", () => {
	Alpine.data("logoController", () => ({
		logoSrc: "",
		fileInputID: "",

		setup(fileInputID, currentLogo) {
			this.fileInputID = fileInputID;
			this.logoSrc = currentLogo;
		},

		selectLogo() {
			document.getElementById(this.fileInputID).click();
		},

		setLogo() {
			const fileElem = document.getElementById(this.fileInputID);

			if (!fileElem.files.length) {
				return;
			}

			let file = fileElem.files[0];
			if (file.type === "image/svg+xml") {
				this.svgToPng(file, (png) => {
					// Create a new File object
					const myFile = new File([png], file.name, {
						type: "image/png",
						lastModified: file.lastModified,
					});

					// Now let's create a DataTransfer to get a FileList
					const dataTransfer = new DataTransfer();
					dataTransfer.items.add(myFile);
					fileElem.files = dataTransfer.files;

					// The file input has been changed to a PNG file
					// now we run this again to set the display src correctly
					this.setLogo();
				});
			}

			window.URL.revokeObjectURL(this.logoSrc);
			this.logoSrc = window.URL.createObjectURL(file);
		},

		deleteLogo() {
			const fileElem = document.getElementById(this.fileInputID);
			fileElem.value = null;
			this.logoSrc = "";
		},

		svgToPng(svgFile, callback) {
			var img = new Image();
			let url = URL.createObjectURL(svgFile);

			img.onload = function () {
				const scale = window.devicePixelRatio * 2;
				let imgH = img.naturalHeight; // original file height
				let imgW = img.naturalWidth; // original file width

				let canvas = document.createElement("canvas");
				canvas.width = imgW;
				canvas.height = imgH;
				canvas["style"]["width"] = `${Math.round(imgW / scale)}px`;
				canvas["style"]["height"] = `${Math.round(imgH / scale)}px`;
				canvas["style"]["margin"] = "0";
				canvas["style"]["padding"] = "0";

				let ctx = canvas.getContext("2d");
				ctx.scale(scale, scale);
				ctx.drawImage(
					img,
					0,
					0,
					Math.round(imgW / scale),
					Math.round(imgH / scale),
				);
				canvas.toBlob(callback, "image/png");
			};

			img.src = url;
		},
	}));
});

window.copyToClipboard = (value) => {
	let tempInput = document.createElement("input");
	tempInput.style = "position: absolute; left: -1000px; top: -1000px";
	tempInput.value = value;
	document.body.appendChild(tempInput);
	tempInput.select();
	document.execCommand("copy");
	document.body.removeChild(tempInput);
	alert("Copied to clipboard");
};

var controller = new AbortController();
window.countNotifications = () => {
	// Abort old requests
	controller.abort();

	// Set a new controller
	controller = new AbortController();
	let { signal } = controller;

	// To know if this specific fetch was aborted
	let aborted = false;
	fetch("/notifications/count", {
		signal: signal,
		credentials: "include",
		method: "GET",
	})
		.then(window.status)
		.then(window.json)
		.then(function (data) {
			let count = data.data;
			if (count > 0) {
				document
					.getElementById("Notifications-desktop-count")
					.classList.remove("hidden");
				document
					.getElementById("Notifications-mobile-count")
					.classList.remove("hidden");
			} else {
				document
					.getElementById("Notifications-desktop-count")
					.classList.add("hidden");
				document
					.getElementById("Notifications-mobile-count")
					.classList.add("hidden");
			}

			document.getElementById("Notifications-desktop-count").innerText = count;
			document.getElementById("Notifications-mobile-count").innerText = count;
		})
		.catch(function (err) {
			if (err.name === "AbortError") {
				aborted = true;
			}
			console.log("Fetch Error: ", err);
		})
		.finally(
			function () {
				if (
					!aborted &&
					typeof pollNotificationCount !== "undefined" &&
					pollNotificationCount === true
				) {
					// recheck every 5 seconds
					window.setTimeout(window.countNotifications, 5000);
				}
			}.bind(this),
		);
};

window.addEventListener("load", function () {
	// Immediately do the first count
	window.countNotifications();
});

// To load our fonts
window.WebFont = require("webfontloader");

window.Alpine = Alpine;
window.Alpine.store("postContent", {
	get: null,
	isEqualTo: null,

	setGetter(value) {
		this.get = value;
	},

	setEqualFunc(value) {
		this.isEqualTo = value;
	},
});

// Start Alpine
Alpine.start();
